<template>
  <button
    class="btn btn-link bg-warning btn-lg d-flex align-items-center justify-content-center text-decoration-none el-scale bg-opacity-05"
    type="button"
    @click="$emit('back')"
    style="width: 56px; height: 56px"
  >
    <IconComponent :lib="'filoxenia'" :icon="'ArrowBack'" />
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconComponent from "@/components/app/_shared/icons/icon-component.vue";

@Options({ components: { IconComponent } })
class BtnBack extends Vue {}
export default BtnBack;
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";
</style>
